import { Component, OnInit, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LocalStorageService } from '@app/core/services/local-storage.service';
import { eUserType } from '@app/shared/enum/user-type';

@Component({
  selector: 'app-confirm-resolve-dispute',
  templateUrl: './confirm-resolve-dispute.component.html',
  styleUrls: ['./confirm-resolve-dispute.component.scss']
})
export class ConfirmResolveDisputeComponent implements OnInit {

  onDataRecieved = new EventEmitter();
  _totalstar = 5;

  constructor(
    public dialogRef: MatDialogRef<ConfirmResolveDisputeComponent>,
    private _domSanitizer: DomSanitizer,
    private _router: Router,
    private _localStorageService: LocalStorageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.data.description = this._domSanitizer.bypassSecurityTrustHtml(this.data.description);
  }

  ngOnInit() {
  }

  closeDialog(): void {
    const userType = parseInt(this._localStorageService.getValueByKey('user_type'));
    if (userType === eUserType.OWNER_OPERATOR) {
      this._router.navigate(['/owner-operator/shipments/disputed-loads']);
    } else if (userType === eUserType.SHIPPER) {
      this._router.navigate(['/shipper/shipments/dispute-loads']);
    } else {
      this._router.navigate(['/carrier/shipments/disputed-loads']);
    }
    this.dialogRef.close();
  }
}
